<template>
  <div>
    <table
      cellpadding="10"
      cellspacing="0"
      width="95%"
      class="hover-table invoices-table"
      align="center"
    >
      <thead>
        <tr>
          <td valign="middle">
            <strong>{{ $t("title.accountChannelLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("title.usernameLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("title.beneficiariesTableDateCreated") }}</strong>
          </td>
          <td  valign="middle">
            <strong>{{ $t("title.ordersTableHeaderStatus") }}</strong>
          </td>
          <td cvalign="middle">
            <!-- <strong>{{ $t("valueLabel") }}</strong> -->
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-if="beneficiary === null">
          <td colspan="6">
            <div class="loading">
              <img src="@/assets/images/loading.gif" />
            </div>
          </td>
        </tr>
        <tr v-else-if="beneficiary.id > 0"
          class="trhover parent gri-cell"
        >
          <td valign="middle">
            email
          </td>
          <td valign="middle">
            {{ beneficiary.email }}
          </td>
          <td valign="middle" >
            {{ displayDate(beneficiary.creation_date) }}
          </td>
          <td valign="middle">
<!--            {{ account.status }}-->
          </td>
        </tr>
        <tr v-else>
          <td colspan="6">
            <span>
              {{ $t("title.beneficiaryNotFoundLabel") }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  import moment from "moment";

  export default {
    name: "BeneficiaryAccountsTable",
    props: {
      beneficiary: Object,
      msg: String,
    },
    data() {
      return {
        transactionError: null,
      };
    },
    methods: {
      displayDate(date) {
        return moment(date, "YYYY-MM-DD-HH.mm.ss.SSSSSS")
          .format("DD/MM/YYYY HH:mm");
      },
    },
  };
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
